<app-header></app-header>
<main class="main-content">
    <!------main-content------>
    <!-----------page_title--------------->
    <section class="page_title  pdt_80  pdb_40">
       <div class="container">
          <div class="row">
             <!---------row----------->
             <div class="col-lg-12 col-md-12 text-center">
                <!---------col----------->
                <div class="content_box">
                   <h6>What is Coronavirus </h6>
                   <h1>About the COVID-19</h1>
                   <ul class="bread_crumb text-center">
                      <li class="bread_crumb-item"><a href="#">Home</a></li>
                      <li class="bread_crumb-item"><a href="#">About</a></li>
                      <li class="bread_crumb-item active"> About COVID-19</li>
                   </ul>
                </div>
                <!---------col-end---------->
             </div>
             <!----------row-end---------->
          </div>
       </div>
    </section>
    <!-----------page_title-end-------------->
    <!-----------about--------------->
    <section class="about type_two pdt_100 pdb_100">
       <div class="container">


          <div class="row">
             
            <div class="col-lg-12 mx-auto">

               <div class="row">
                  <div class="col-lg-12 text-center">
                     <div class="heading-minister"> Organization chart of the Ministry of Health and Social Welfare </div>
                  </div>
               </div>

                  <div class="row">

                     <div class="col-lg-3 col-md-3 offset-lg-3 offset-md-3">
                        <div class="image_box_1">
                           <img class="minister-img" src="assets/image/p1.png">
                        </div>
                        <div class="text-about">
                           <h3>Diosdado Vicente Nsue Milang<br><small>( Minister )</small></h3>
                           
                        </div>
                      </div>
         
                      <div class="col-lg-3 col-md-12">
                        <div class="image_box_1">
                           <img class="minister-img" src="assets/image/p2.png">
                        </div>
                        <div class="text-about">
                           <h3>Mitoha Ondo'o Ayekaba<br><small>( Vice Minister )</small></h3>
                           
                        </div>
                      </div>

                  </div>

                  <div class="row mx-auto">
                     <div class="col-lg-8 offset-lg-2">
                        <div class="text-minister-1 text-center">
                        Behind the Minister VE  Diosdado Vicente Nsue Milang,   as well as the Vice Minister, VE  Mitoho Ondo'o Ayekaba  is a management team and its staff with an excellent disposition to support both the ministerial institution and its two senior executive officers.
                        </div>
                     </div>
                  </div>


            </div>


          </div>


          <!-- <div class="row">
            
             <div class="col-lg-6 col-md-12">
               
                <div class="image_box">
                   <img src="assets/image/resources/about-page-1-1.png" class="img-fluid" alt="img" />
                </div>
               
             </div>
             <div class="col-lg-6 col-md-12 d-flex">
                
                <div class="about_content">
                   <div class="heading tp_one">
                      <h1> Pandemic of Coronavirus Disease 2019-2020 </h1>
                   </div>
                   <p> It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years.
                   </p>
                   <p> It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
                </div>
                
             </div>
            
          </div> -->
          <div class="empty_space"></div>
          <div class="row">
             <!---------row----------->
             <div class="col-lg-6 col-md-12 d-flex">
                <!---------col----------->
                <div class="about_content">
                   <div class="heading tp_one">
                      <h1> What is the COVID-19 virus?</h1>
                   </div>
                   <p>COVID-19 is an infectious disease caused by the coronavirus. Both this new virus and the disease it causes were unknown before the outbreak broke out in Wuhan (China) in December 2019. Currently, COVID-19 is a pandemic that affects almost every country in the world.
 
                   </p>
                   <h2> Most common symptoms</h2>
                   <p class="last">The most common symptoms of COVID-19 are: fever, dry cough, and tiredness. Others less frequent are discomfort, nasal congestion, headache, conjunctivitis, sore throat, diarrhea, loss of taste or smell and skin rashes or color changes in the fingers or toes.<br>
                     Most people (about 80%) recover from the disease without the need for hospital treatment. About 1 in 5 people who contract COVID-19 end up with a severe condition and experience breathing difficulties.<br>
                     Older people and those with previous medical conditions such as high blood pressure, heart or lung problems, diabetes, or cancer are more likely to have severe conditions. However, anyone can get COVID-19 and become seriously ill.
                   </p>
                </div>
                <!---------col-end---------->
             </div>
             <div class="col-lg-6 col-md-12">
                <!---------col----------->
                <div class="image_box">
                   <img src="assets/image/resources/protect-1-1.png" class="img-fluid" alt="img">
                </div>
                <!---------col-end---------->
             </div>
             <!----------row-end---------->
          </div>
       </div>
    </section>
    <!-----------about-end-------------->
   
    
<app-footer></app-footer>
   
 </main>
 
 <app-scrolltotop></app-scrolltotop>
<app-whatsupchat></app-whatsupchat>
